module.exports = __webpack_public_path__ + "assets/normal/images/share16.b4cd7511.png";